<template>
<div>
    <div class="grid-container statistics-header" >
        <statistics-header v-for="(title, i) in titles"
            :key="`${title}-${i}`" 
            :title="title"
        />
    </div>

    <div class="statistics-divider">

    </div>

    <div class="grid-container statistics-columns">
        <statistics-column v-for="(column, index) in row"
            :key="`${column.name}-${index}`"
            :items="column.items"
        />
    </div>
</div>
</template>

<script>

import StatisticsHeader from './StatisticsHeader.vue';
import StatisticsColumn from './StatisticsColumn.vue';

export default {
    name: 'statistics-section',
    components: {
        StatisticsHeader,
        StatisticsColumn
    },
    computed: {
        titles() {
            return this.row.map((column) => column.name);
        }
    },
    props: {
        row: {
            type: Array,
            required: true
        }
    }
}
</script>